import { datadogRum } from "@datadog/browser-rum"
import { reactPlugin } from "@datadog/browser-rum-react"

datadogRum.init({
  applicationId: process.env.GATSBY_DATADOG_APP_ID || "1fc6932d-b1fc-40c1-86be-0230275a8381",
  clientToken: process.env.GATSBY_DATADOG_CLIENT_TOKEN || "pube57d37608237634a0361323f98f1f252",
  site: "datadoghq.com",
  service: "edge-frontend",
  env: process.env.NODE_ENV || "prod",
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: "mask-user-input",
  plugins: [reactPlugin({ router: false })],
})
